// @flow

import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Header from "../Header";
import QuotePage from "../QuotePage";
import PaymentPage from "../PaymentPage";
import LoginPage from "../LoginPage";
import ConfirmPage from "../ConfirmPage";
import CompleteBooking from "../CompleteBooking";
import ForgottenPage from "../ForgottenPage";
import ChangePasswordPage from "../ChangePasswordPage";
import Footer from "../Footer";
import withProgressBar from "../../components/ProgressBar";
import Notifications from "../../components/Notifications/";
import QuoteButton from "../../components/QuoteButton/";
import { Provider, ErrorBoundary } from "@rollbar/react";

// Rollbar Configutation
const rollbarConfig = {
  accessToken: 'acd69dfefca24f779a2d373730a67de8',
  environment: process.env.NODE_ENV, 
  captureUncaught:true,
  captureUnhandledRejections:true
};

export const mainSiteRedirect =  () => {

  window.location.href = "https://www.ski-lifts.com/";
  
  return (
    <h1 style={{ color: "#ffffff" }}>
      Redirecting to main site
    </h1>
  );
}

export class App extends Component<void> {
  
  

  render() {
    
    return (
      <Provider config={rollbarConfig}>
        <ErrorBoundary>
          <div>
            <BrowserRouter>
              <div className="container-fluid" style={{ padding: "0px" }}>
                <Header />
                <Switch>
                  <Route path="/quote/:id" component={QuotePage} />
                  <Route exact path="/payment" component={PaymentPage} />
                  <Route exact path="/login" component={LoginPage} />
                  <Route exact path="/confirm" component={ConfirmPage} />
                  <Route exact path="/complete" component={CompleteBooking} />
                  <Route exact path="/forgot" component={ForgottenPage} />
                  <Route
                    exact
                    path="/changepassword/:key/:id"
                    component={ChangePasswordPage}
                  />
                  <Route
                    exact
                    path="/recovery/activkey/:key/basketId/:id"
                    render={({ match }) => (
                      <Redirect
                        to={`/changepassword/${match.params.key}/${match.params.id}`}
                      />
                    )}
                  />
                  {process.env.NODE_ENV !== "production" &&
                    process.env.REACT_APP_QUOTE_PATH && <QuoteButton />}
                  <Route
                    path=""
                    component={mainSiteRedirect}
                  />
                </Switch>
                <Footer />
                <Notifications />
              </div>
            </BrowserRouter>
          </div>
      </ErrorBoundary>
      </Provider>
    );
  }
}

export default withProgressBar(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js